import * as appsActions from '~/actions/apps.action';
import { ActionKeys } from '~/actions/constants';
import { AxiosResponse } from 'axios';
import { call, takeLatest } from 'redux-saga/effects';
import * as appsService from '~/services/apps.service';
import { camelizeKeys } from '~/utils/humps';

export function* getAuthorizedApps(action: ReturnType<typeof appsActions.getAuthorizedApps>) {
  try {
    const response: AxiosResponse = yield call(appsService.getAuthorizedApps);
    action.callback(camelizeKeys(response.data));
  } catch (err) {
    action.callback({ err });
  }
}

export function* deleteAuthorizedApps(action: ReturnType<typeof appsActions.deleteAuthorizedApps>) {
  try {
    const response: AxiosResponse = yield call(appsService.deleteAuthorizedApps, action.id);
    action.callback(camelizeKeys(response.data));
  } catch (err) {
    action.callback({ err });
  }
}

export default [
  takeLatest(ActionKeys.FETCH_APPS, getAuthorizedApps),
  takeLatest(ActionKeys.DELETE_APP, deleteAuthorizedApps),
];
